module.exports = __webpack_public_path__ + "img/Controll center.efe91a71.svg";